import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { formatDataToSend, filterConstantsToSend, removeUndefinedFromObject } from './utils.js';

var gtmEvent = function gtmEvent(_ref) {
  var hash = _ref.hash,
    eventType = _ref.eventType,
    userData = _ref.userData,
    data = _ref.data,
    dimensions = _ref.dimensions;
  var formattedData = formatDataToSend({
    userData: userData,
    assetData: data
  });
  var originalDimensions = {};
  originalDimensions = (dimensions === null || dimensions === void 0 ? void 0 : dimensions.length) > 0 ? filterConstantsToSend(dimensions, formattedData) : formattedData;
  var constantToSend = removeUndefinedFromObject(originalDimensions);
  var dataLayer = _objectSpread({
    hash: hash,
    event: eventType
  }, constantToSend);
  if (window.dataLayer) window.dataLayer.push(dataLayer);
};

export { gtmEvent };
//# sourceMappingURL=gtmEvent.js.map
